import type { CommandData } from '../types'

export function setInputValue(value: string) {
  const message: CommandData = {
    isFromBeeetle: true,
    command: 'setInputValue',
    value,
  }
  window.postMessage(message)
}
